import { renderComponent, branch } from 'recompose';
import Loading from '../components/Loading';

export const renderWhileLoading = (propName = 'data') => branch(
    props => props[propName] && props[propName].loading,
    renderComponent(Loading),
  );